import { Container } from "react-bootstrap";
import { RouteProps } from "react-router";
import Content from "Types/Content";

const FacundoMidvetkin: React.FC<RouteProps> = () => {
  return (
    <Container className='pt-3'>
      Facundo Midvetkin
      <br />
      Front-End
    </Container>
  );
};

export default new Content({
  Component: FacundoMidvetkin,
  title: "Facundo Midvetkin",
  route: "facundo-midvetkin",
  tags: ["trainee"]
});
